import { QueryObserverOptions, useQuery } from 'react-query';
import { InspectionDTO } from '../dtos/InspectionDTO';
import getInspectionById from '../api';

type UseQueryOptionsKeys = Pick<QueryObserverOptions<InspectionDTO>, 'enabled'>;

export default function useGetInspection(inspectionId: number, options?: UseQueryOptionsKeys) {
  const { data, isFetching } = useQuery(
    ['getInspectionById', inspectionId],
    () => getInspectionById(inspectionId),
    {
      ...options,
    }
  );

  return { inspectionDTO: data, isFetchingInspectionDTO: isFetching };
}
